import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFAlternatorH5, EFSolarPowerH5, EFSmartGeneratorH5, EFShorePowerH5, EFVideoPlayer, EFShorePowerAU, EFProductWinAdd } from '@/components/UI/svg/mm100';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ type = 'offGrid', customClass, callBack }: any) {
    const { useLang, useEffect, useState, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);
    let controller: any;
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap = {
        us: 'https://www.youtube.com/embed/wwGcveNTQj8',
        jp: 'https://www.youtube.com/embed/iKYLTKkiFuo',
        cn: {
            SD: 'https://videos.ecoflow.com/6ca58e33e6854db7962947fbf1923f5d/bb08627bbeec449b885e6c41d308b4a1-4ad54e6b8124b7d9c219943feae68eed-fd.mp4',
            HD: 'https://videos.ecoflow.com/6ca58e33e6854db7962947fbf1923f5d/bb08627bbeec449b885e6c41d308b4a1-7e5be3916e3740938880b802ba814ffd-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/345a5e67-1841d8eec62-0004-9c91-e6d-40030.mp4',
        },
    };

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.kitE .video-box`,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1.2, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });

        controller.addScene(sceneA1);
    }, []);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Compact and Integrated Power Solution',
            position,
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.kitE} kitE ${customClass}`}>
            <div className="kit-inter">
                <div className="kit-ms1">
                    {type === 'offGrid'
                        ? t(locale === 'kr' ? 'presale.product.kitE_off_grid_ms1_h5' : 'presale.product.kitE_off_grid_ms1')
                        : t('presale.product.kitE_rv_ms1')}
                </div>
                <div className="kit-ms2">
                    {type === 'offGrid'
                        ? t(locale === 'kr' ? 'presale.product.kitE_off_grid_ms2_h5' : 'presale.product.kitE_off_grid_ms2')
                        : t(locale === 'kr' ? 'presale.product.kitE_rv_ms2_h5' : 'presale.product.kitE_rv_ms2')}
                </div>
                <div className="kit-ms3">{t('presale.product.kitE_ms3')}</div>
                <div className="watch-video-btn" onClick={() => playerVideo(t('presale.product.kitE_rv_ms1'))}>
                    {t('presale.product.watch_video')}
                    <EFVideoPlayer className="icon" color="#2673ff" />
                </div>
                <div className="more-win-fun" onClick={() => callBack('CablePack')} style={{ display: locale === 'us' ? 'inline-block' : 'none' }}>
                    {t('presale.product.h5_learn_more')}
                    <span className="more-win-fun-icon">
                        <EFProductWinAdd />
                    </span>
                </div>
                <div className="list-box">
                    <div className="list-item left-item">
                        <div className="list-img">
                            <EFSolarPowerH5 width="0.39rem" height="0.41rem" />
                        </div>
                        <div className="list-ms1">4800W</div>
                        <div className="list-ms2">{t('presale.product.kitE_list_box1_ms2')}</div>
                    </div>
                    <div className="list-item">
                        <div className="list-img">
                            <EFSmartGeneratorH5 width="0.41rem" height="0.41rem" />
                        </div>
                        <div className="list-ms1">1800W</div>
                        <div className="list-ms2">{t('presale.product.kitE_list_box2_ms2')}</div>
                    </div>
                    {type === 'rv' && (
                        <>
                            <div className="list-item left-item">
                                <div className="list-img">
                                    {locale === 'au' ? (
                                        <EFShorePowerAU width="0.32rem" height="0.41rem" />
                                    ) : (
                                        <EFShorePowerH5 width="0.32rem" height="0.41rem" />
                                    )}
                                </div>
                                <div className="list-ms1">3000W</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box3_ms2')}</div>
                            </div>
                            <div className="list-item">
                                <div className="list-img">
                                    <EFAlternatorH5 width="0.36rem" height="0.41rem" />
                                </div>
                                <div className="list-ms1">{locale !== 'cn' ? '1000W' : '1600W'}</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box4_ms2')}</div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            {type === 'rv' ? (
                <div className="video-box">
                    {videoEnterA && <EFVideo sources={['/video/mm100m/kitE_h5_rv_1.webm', '/video/mm100/kitE_h5_rv_1.mp4']} className="video kitE-video" />}
                    <span className="text-top-left text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box1_ms2_cn' : 'presale.product.kitE_list_box1_ms2')}
                    </span>
                    <span className="text-top-right text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box4_ms2_cn' : 'presale.product.kitE_list_box4_ms2')}
                    </span>
                    <span className="text-bottom-left text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box3_ms2_cn' : 'presale.product.kitE_list_box3_ms2')}
                    </span>
                    <span className="text-bottom-right text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box2_ms2_cn' : 'presale.product.kitE_list_box2_ms2')}
                    </span>
                </div>
            ) : (
                <div className="video-box">
                    {videoEnterA && (
                        <EFVideo sources={['/video/mm100m/kitE_h5_offGrid_1.webm', '/video/mm100/kitE_h5_offGrid_1.mp4']} className="video kitE-video" />
                    )}
                    <span className="text-top-right text">{t('presale.product.kitE_list_box1_ms2')}</span>
                    <span className="text-bottom-right text">{t('presale.product.kitE_list_box2_ms2')}</span>
                </div>
            )}
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
